var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"address-modal"}},[_c('b-modal',{attrs:{"id":"address-modal","hide-footer":"","title":"Editando Dirección"}},[_c('EditAddress',{attrs:{"address":_vm.address},on:{"hideForm":_vm.hideModal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }